<template>
  <svg
    :class="computedClass"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path :d="iconPath" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { getIconPath } from '@/constants/icons'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: 'md'
  },
  strokeWidth: {
    type: [String, Number],
    default: '2'
  },
  class: {
    type: String,
    default: ''
  }
})

const sizeClasses = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
  xl: 'w-8 h-8',
  '2xl': 'w-10 h-10'
}

const iconPath = computed(() => getIconPath(props.name))

const computedClass = computed(() => {
  const baseClass = sizeClasses[props.size] || sizeClasses.md
  return props.class ? `${baseClass} ${props.class}` : baseClass
})
</script>
